export interface IObjectsById<R> {
    [resource_id: string]: R;
}
